export const getStatusColor = (status) => {
  if (status.toLowerCase() === 'draft') {
    return '#333';
  }
  if (status.toLowerCase() === 'to be approved') {
    return '#EDB526';
  }
  if (status.toLowerCase() === 'scheduled for publish') {
    return '#8757D6';
  }
  if (status.toLowerCase() === 'published') {
    return '#0BD3BB';
  }
  if (status.toLowerCase() === 'scheduled for invite') {
    return '#3F7DDA';
  }
  if (status.toLowerCase() === 'invited') {
    return '#66D184';
  }
  if (status.toLowerCase() === 'canceled') {
    return '#999999';
  }
  if (status.toLowerCase() === 'archived') {
    return '#98673A';
  }
  return '#333';
};